function Loader() {
    return (
        <div className="loader-wrapper">
            <span className="loader-2"></span>
        </div>
    )
}

export default Loader
